<template>
  <v-layout justify-center pa-5 wrap>
    <v-flex px-2 lg10 sm10 md11 xs12>
      <v-layout wrap>
        <TitleDescription :chapterID="$route.params.chapterID"/>
        <files-list :files="files" style="margin-top:25px;"/>
        <files-input :contentFiles="files"/>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import TitleDescription from "@/components/contents/TitleDescription";
import FilesList from "./FilesList";
import FilesInput from "./FilesInput"
import { updateContent } from "@/firebase/api/content";

export default {
  components: { TitleDescription, FilesList, FilesInput },
  mounted()  {
    const filesAreDefined = !!this.content.files
    const contentWasLoaded = Object.keys(this.content).length > 0
    if(contentWasLoaded && !filesAreDefined) {
      const files = []
      const { chapterID, contentID } = this.$route.params;
      updateContent(chapterID, contentID, { files });
    }
  },
  props: { content: Object },
  computed: {
    contentWasLoaded() {
      return Object.keys(this.content).length > 0
    },
    files() {
      return this.contentWasLoaded && !!this.content.files ? this.content.files : []
    },
  }
};
</script>

<style scoped>
* {
  transition: all ease-in-out;
}
</style>
